import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const USER_EMAIL_NOTIFICATION_PREFERENCE_UPDATE = gql(`
  mutation userEmailNotificationPreferenceUpdate($emailCategory: EmailNotificationCategory!, $value: Boolean!) {
    userEmailNotificationPreferenceUpdate(emailCategory: $emailCategory, value: $value) {
      __typename
      id
      preferences {
        __typename
        emailNotifications {
          __typename
          MarketingDisabled
          ReleaseNotesDisabled
          OnboardingDisabled
          OrganizationUpdatesDisabled
          DeploymentUpdatesDisabled
        }
      }
    }
  }
`);

export function useUserEmailNotificationPreferenceUpdate() {
  return useMutation(USER_EMAIL_NOTIFICATION_PREFERENCE_UPDATE);
}
